import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notification } from 'antd';

import { NOTIFICATION_CONFIG, NOTIFICATION_MESSAGES } from '@/shared/lib/constants';
import { dagKeys } from '@/shared/lib/query/queryKeys';

import { updateDagApi } from '@/entities/dag/api';
import type { UpdateDagRequest, UpdateDagResponse } from '@/entities/dag/domain/types';

export const useUpdateDagMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<UpdateDagResponse, Error, UpdateDagRequest>({
    mutationFn: (request) => updateDagApi(request),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: dagKeys.all });

      notification.success({
        message: NOTIFICATION_MESSAGES.DAG_UPDATE_SUCCESS,
        description: `${variables.dagUuid} - ${NOTIFICATION_MESSAGES.DAG_UPDATE_SUCCESS_DESC}`,
        placement: NOTIFICATION_CONFIG.PLACEMENT,
        duration: NOTIFICATION_CONFIG.DURATION.SUCCESS,
      });
    },
    onError: (error, variables) => {
      console.error('Failed to update DAG metadata:', error);

      notification.error({
        message: NOTIFICATION_MESSAGES.DAG_UPDATE_ERROR,
        description: `${variables.dagUuid} - ${NOTIFICATION_MESSAGES.DAG_UPDATE_ERROR_DESC}`,
        placement: NOTIFICATION_CONFIG.PLACEMENT,
        duration: NOTIFICATION_CONFIG.DURATION.ERROR,
      });
    },
  });
};
